import { createContext, useContext, type Dispatch, type ReactNode, type SetStateAction } from "react";
import type { ForgeRemoteDataSourceKind } from "../api/contracts";
import type { Capability, DialogState, ForgeRemoteFixture } from "../domain";
import type { RemoteActions } from "./remoteQueries";

interface RemoteContextValue {
  fixture: ForgeRemoteFixture;
  actions: RemoteActions;
  dialog: DialogState;
  setDialog: Dispatch<SetStateAction<DialogState>>;
  can: (capability: Capability) => boolean;
  canMutate: boolean;
  mutationBlockReason: string | null;
  canChat: boolean;
  managerBlockReason: string | null;
  historyReset: boolean;
  sourceKind: ForgeRemoteDataSourceKind;
}

const RemoteContext = createContext<RemoteContextValue | null>(null);

export function RemoteProvider({ value, children }: { value: RemoteContextValue; children: ReactNode }) {
  return <RemoteContext.Provider value={value}>{children}</RemoteContext.Provider>;
}

export function useRemote() {
  const value = useContext(RemoteContext);
  if (!value) throw new Error("useRemote must be used inside RemoteProvider.");
  return value;
}
